import { createAction } from '@ngrx/store';

export const e911Changed = createAction('[E911 Hub] E911 Changed.');
